import React, { useState, useEffect } from 'react';
import axios from 'axios';
import StockAlerts from '../components/StockAlerts';
import SalesDashboard from '../components/SalesDashboard';
import Inventory from '../components/Inventory';
import PillSpinner from '../components/PillSpinner';

const API_URL = 'http://localhost:5000/api';

const Dashboard = () => {
  const [medicines, setMedicines] = useState([]);
  const [todaySales, setTodaySales] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchMedicines = async () => {
    const res = await axios.get(`${API_URL}/medicines`);
    setMedicines(res.data);
  };

  const fetchTodaySales = async () => {
    const res = await axios.get(`${API_URL}/sales/today`);
    setTodaySales(res.data.total);
  };

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      await Promise.all([fetchMedicines(), fetchTodaySales()]);
      setLoading(false);
    };
    fetchAll();
  }, []);

  const addMedicine = async (medicine) => {
    await axios.post(`${API_URL}/medicines`, medicine);
    fetchMedicines();
  };

  const updateStock = async (id, change) => {
    await axios.patch(`${API_URL}/medicines/${id}/stock`, { stockChange: change });
    fetchMedicines();
  };

  const recordSale = async (sale) => {
    await axios.post(`${API_URL}/sales`, sale);
    fetchTodaySales();
    fetchMedicines();
  };

  const filteredMedicines = medicines.filter(med =>
    med.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <PillSpinner />;

  return (
    <div>
      <div className="dashboard-container">
        <SalesDashboard todaySales={todaySales} />
        <StockAlerts medicines={medicines} />
      </div>
      <Inventory
        medicines={filteredMedicines}
        allMedicines={medicines}
        addMedicine={addMedicine}
        updateStock={updateStock}
        recordSale={recordSale}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </div>
  );
};

export default Dashboard;